import { svg } from 'lit';
import { type IconBase, createIconComponent } from '../Icon.component';

/** List of icons here : https://lamaille.supernova-docs.io/latest/foundations/iconography-system-xiZRSP4Z#search-7b7542c0-4d44-11ec-8ce5-cb0f56bcf344 **/
export const IconCheck = createIconComponent(
    'lr-icon-check',
    svg`
<path xmlns="http://www.w3.org/2000/svg" d="M6 16.7778L12.1538 23L26 9" stroke="currentcolor" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round"/>
`
);

declare global {
    interface HTMLElementTagNameMap {
        'lr-icon-check': IconBase;
    }
}
